import { Controller } from '@hotwired/stimulus';
import { parsePhoneNumber } from 'libphonenumber-js'

// Connects to data-controller="country-code-detector"
export default class extends Controller {
  static targets = ['countrySelect']

  fetchCountry(e) {
    e.preventDefault()

    try {
      const phoneNumber = parsePhoneNumber(e.target.value)
      e.target.value = phoneNumber.nationalNumber
      this.countrySelectTarget.value = phoneNumber.country
      this.countrySelectTarget.dispatchEvent(new Event("change", { bubbles: true }));
    } catch (error) {
      // noop
    }
  }
}
